import { render, staticRenderFns } from "./CardPagamentos.vue?vue&type=template&id=8f394a08&"
import script from "./CardPagamentos.vue?vue&type=script&lang=js&"
export * from "./CardPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports